import { useMemo } from "react"
import { get } from "lodash"
import { matchPath, useLocation } from "react-router-dom"
import { Box, SxProps, Theme, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useGetAppConfig } from "providers/venue/modules/data"
import { useKioskConfig } from "providers/venue/modules/data/kiosk-config/useKioskConfig"

import { SplitrPlayer } from "components/Splitr"
import { SponsoredContentScreenSaverPlayer } from "./SponsoredContentScreenSaverPlayer"

interface IHomeScreenSaverProps {
  sx?: SxProps<Theme>
}

export const HomeScreenSaver: React.FC<IHomeScreenSaverProps> = ({
  sx = {},
}) => {
  const location = useLocation()
  const hidden = !matchPath("/", location.pathname)
  const { data: appConfig } = useGetAppConfig()
  const { screenSaverConfig } = appConfig ?? {}

  const { kioskConfigName, kioskConfig } = useKioskConfig()
  const campaignId = useMemo(
    () => get(kioskConfig, "source.properties.sCampaignId") ?? undefined,
    [kioskConfig]
  )

  const theme = useTheme()
  const { styleOverrides = {} } = theme.components?.[`HomePage`] || {}
  const { screensaverContainer } = styleOverrides

  if (hidden) return null

  if (screenSaverConfig?.provider === "local") {
    return (
      <Box sx={deepmerge(screensaverContainer, sx)}>
        <SponsoredContentScreenSaverPlayer />
      </Box>
    )
  }

  if (screenSaverConfig?.provider === "splitr") {
    return (
      <SplitrPlayer
        hidden={hidden}
        campaignId={campaignId}
        deviceName={kioskConfigName}
        sx={sx}
      />
    )
  }
}
